import { DateHelperUtil } from '../../../../utils/date-helper/date-helper.util';

export interface PCLBRPModernizationDetailsApi {
  WylozId: string;
  DaneKontaktowe: string;
  Info: string;
  DataDo: string;
  DataOd: string;
}

export class PCLBRPModernizationDetails {
  constructor(
    public id: string,
    public contactDetails: string,
    public info: string,
    public apiDateFrom: string,
    public apiDateTo: string,
    public uiDateFrom: string,
    public uiDateTo: string,
  ) {}

  static fromApiToApp(
    modernizationDetails: PCLBRPModernizationDetailsApi,
  ): PCLBRPModernizationDetails {
    return new PCLBRPModernizationDetails(
      modernizationDetails.WylozId,
      modernizationDetails.DaneKontaktowe,
      modernizationDetails.Info,
      modernizationDetails.DataOd,
      modernizationDetails.DataDo,
      DateHelperUtil.apiToUiDateTime(modernizationDetails.DataOd),
      DateHelperUtil.apiToUiDateTime(modernizationDetails.DataDo),
    );
  }
}
